import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const ViewImage = ({ isOpen, toggle, selectedItem }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} scrollable={true} size="lg">
      <ModalHeader toggle={toggle}>{selectedItem?.name}</ModalHeader>
      <ModalBody>
        <img src={selectedItem?.cloudR2Path?.getCDNUrl()} className="img-fluid w-100 h-100 object-fit-contain"/>
      </ModalBody>
    </Modal>
  );
};

export default ViewImage;
